import { translate } from "../../util/translate"

export const itemStatusHeader = [
    {
      text: translate['realty.label.code'],
      value: 'realty.code',
      width: 60,
    },
    {
      text: translate['realty.label.address'],
      value: 'realty.address',
      width: '15vw',
    },
    {
      text: translate['financial.label.serviceDone'],
      value: 'done',
      width: '5vw',
    },
]
